import { useTranslation } from "react-i18next";

/**
 * T56a — in-app maintenance banner. Presentational only; the mode is decided
 * server-side (root loader reads the `MAINTENANCE_MODE` KV flag). Colour intent:
 * `read-only` = amber (saving paused, reading still works); `full` = slate care —
 * a deliberate pause, not an alarm.
 */
export function MaintenanceBanner({
  mode,
  statusHref,
}: {
  mode: "read-only" | "full";
  statusHref: string;
}) {
  const { t } = useTranslation("maintenance");
  const isReadonly = mode === "read-only";

  return (
    <div
      className={`mm-banner ${isReadonly ? "is-readonly" : "is-full"}`}
      role="status"
      aria-live="polite"
    >
      <svg
        className="ic"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        strokeWidth={1.6}
        strokeLinecap="round"
        strokeLinejoin="round"
        aria-hidden="true"
      >
        <path d="M14.7 6.3a4 4 0 0 0-5.4 5.2L4 16.8V20h3.2l5.3-5.3a4 4 0 0 0 5.2-5.4l-2.5 2.5-2.3-.6-.6-2.3 2.4-2.6Z" />
      </svg>
      <div className="txt">
        <strong>{t(isReadonly ? "banner_readonly_title" : "banner_full_title")}</strong>
        <span className="sub">{t(isReadonly ? "banner_readonly_body" : "banner_full_body")}</span>
      </div>
      <a className="link" href={statusHref}>
        {t("banner_status_link")}
      </a>
    </div>
  );
}
